
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/faq/self-employed",
      function () {
        return require("private-next-pages/[locale]/faq/self-employed/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/faq/self-employed"])
      });
    }
  